import { isEqual } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import {
    areAllGroupedByMonthOrderSelected,
    areSomeGroupedByMonthOrderSelected,
    toggleGroupedByMonthOrderItemsSelect,
} from '../../../../ducks/billItems';

interface StateProps {
    allSelected: boolean;
    someSelected: boolean;
}

interface OwnProps {
    billId: string;
    scope: string;
    month: string;
}

interface DispatchProps {
    toggleSelect: () => void;
}

export const connectMonthListItem = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        allSelected: areAllGroupedByMonthOrderSelected,
        someSelected: areSomeGroupedByMonthOrderSelected,
    }),
    (dispatch: CommanderThunkDispatch, { month, billId, scope }) => ({
        toggleSelect: () => dispatch(toggleGroupedByMonthOrderItemsSelect({ month, billId, scope })),
    }),
    null,
    {
        areStatePropsEqual: isEqual,
    }
);
